<template>
  <div class="structured-description__preferrals container-inner container-content">
    <h2 class="structured-description__title-md">{{ preferralsData.title }} </h2>

    <div class="structured-description__block-content">
      <div class="structured-description__preferrals-image border-colored-image-card _image-double-card">
        <img :src="preferralsData.image" alt="">
      </div>
      <div>
        <div class="structured-description__preferrals-list">
          <div
            v-for="(item, index) in preferralsData.items"
            :key="index"
            class="structured-description__list-item-card"
          >
            <div class="structured-description__list-item-card-icon">
              <img :src="item.icon"  alt="" />
            </div>
            <div class="structured-description__list-item-card-text">
              {{ item.item }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StructuredDescriptionPreferrals',
  props: {
    preferralsData: {
      type: Object,
      required: true,
    },
  },
};
</script>
